module.exports = __webpack_public_path__ + "img/mz.bdc52af5.svg";